import client from './client'
import type {
  CancellationPolicyData,
  UpsertCancellationPolicyPayload,
} from '@/types/cancellation-policy'

export async function fetchCancellationPolicy(
  editionId: number,
): Promise<CancellationPolicyData | null> {
  const { data } = await client.get<{ data: CancellationPolicyData | null }>(
    `/organizer/editions/${editionId}/cancellation-policy`,
  )
  return data.data
}

export async function upsertCancellationPolicy(
  editionId: number,
  payload: UpsertCancellationPolicyPayload,
): Promise<CancellationPolicyData> {
  const { data } = await client.put<{ data: CancellationPolicyData }>(
    `/organizer/editions/${editionId}/cancellation-policy`,
    payload,
  )
  return data.data
}
